var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',_vm._g(_vm._b({staticClass:"position-relative"},'b-button',_vm.$attrs,false),_vm.$listeners),[_c('LoadingButtonContent',{attrs:{"busy":_vm.busy}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }